<template>
  <v-card>
    <v-card-title class="title">
      {{ $t('Terms of Service') }}
    </v-card-title>

    <v-divider/>

    <v-card-text v-html="tos.contents"/>

    <v-divider/>

    <v-card-actions class="px-3">
      <v-checkbox v-model="accepted">
        <template v-slot:label>
          <div>
            {{ $t('I have read and agree to the FutureEcom') }}
            <a
              target="_blank"
              href="https://www.futureecom.com/terms-of-service/"
              @click.stop
            >
              {{ $t('Terms of Service') }}
            </a>
          </div>
        </template>
      </v-checkbox>
      <v-spacer/>
      <v-btn
        :disabled="!accepted"
        color="green"
        class="white--text"
        @click="accept"
      >
        {{ $t('Accept') }}
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex'

export default {
  name: 'TermsOfService',

  props: {
    tos: {
      required: true,
      type: Object
    }
  },

  data () {
    return {
      accepted: false
    }
  },

  computed: {
    ...mapGetters({ user: 'auth/me' })
  },

  methods: {
    ...mapMutations({
      'setUser': 'auth/ME'
    }),

    async accept () {
      const user = this.$http.make('auth:user', this.user.payload())
      user.accepted_tos = this.tos.version
      user.save()

      this.setUser(this.$http.make('auth:user', user.without(['password', 'password_confirmation']).payload()))

      this.$emit('accepted')
    }
  }
}
</script>
